import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
    ActivatedRoute,
    Router,
    RouterEvent,
    NavigationStart,
    NavigationEnd,
    NavigationCancel,
    NavigationError,
    RoutesRecognized,
    GuardsCheckStart,
    GuardsCheckEnd,
    RouteConfigLoadStart,
    RouteConfigLoadEnd,
    ChildActivationStart,
    ChildActivationEnd,
    ActivationStart,
    ActivationEnd,
    Scroll,
    ResolveStart,
    ResolveEnd
} from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export interface ISubMenuItem {
    label: string;
    route: string;
}

@Component({
    selector: 'lynkd-pattern-sub-menu',
    templateUrl: './sub-menu.component.html',
    styleUrls: ['./sub-menu.component.scss']
})
export class SubMenuComponent implements OnInit, OnDestroy {
    @Input() public items: Array<ISubMenuItem> = [];
    @Input() public ariaLabel: string = 'Menu selection';

    public selectedItem: string = '';

    private readonly _destroy$: Subject<void> = new Subject<void>();

    public constructor(private readonly _router: Router, private readonly _route: ActivatedRoute) {}

    public ngOnInit(): void {
        this._router.events
            .pipe(
                filter(
                    (
                        event:
                            | RouterEvent
                            | NavigationStart
                            | NavigationEnd
                            | NavigationCancel
                            | NavigationError
                            | RoutesRecognized
                            | GuardsCheckStart
                            | GuardsCheckEnd
                            | RouteConfigLoadStart
                            | RouteConfigLoadEnd
                            | ChildActivationStart
                            | ChildActivationEnd
                            | ActivationStart
                            | ActivationEnd
                            | Scroll
                            | ResolveStart
                            | ResolveEnd
                    ) => event instanceof NavigationEnd
                ),
                takeUntil(this._destroy$)
            )
            .subscribe(() => {
                this.updateSelectedItem();
            });

        this.updateSelectedItem();
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public async onItemChange(route: string): Promise<boolean> {
        this.selectedItem = route;
        return this._router.navigate([route], { relativeTo: this._route });
    }

    private updateSelectedItem(): void {
        const childRoute: ActivatedRoute = this._route.firstChild;
        if (childRoute?.snapshot.url.length > 0) {
            this.selectedItem = childRoute.snapshot.url[0].path;
        } else if (this.items.length > 0) {
            this.selectedItem = this.items[0].route;
        }
    }
}
